import { render, staticRenderFns } from "./VineyardSimpleFertilizerMetricTable.vue?vue&type=template&id=5513eade&scoped=true&"
import script from "./VineyardSimpleFertilizerMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardSimpleFertilizerMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513eade",
  null
  
)

export default component.exports